var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24678 0.24221C5.53014 0.489703 5.55898 0.920009 5.31172 1.20337L2.8469 4.02486H12.3825C15.112 4.02486 17.3327 6.24553 17.3327 8.97483C17.3327 11.7041 15.1118 13.9248 12.3825 13.9248H8.29164C7.91541 13.9248 7.61046 13.6198 7.61046 13.2436C7.61046 12.8674 7.91541 12.5624 8.29164 12.5624H12.3825C14.3609 12.5624 15.9703 10.953 15.9703 8.97483C15.9703 6.99664 14.3609 5.38723 12.3825 5.38723H2.8469L5.31172 8.20871C5.55921 8.49208 5.53018 8.92239 5.24678 9.16988C5.11758 9.28274 4.95798 9.33814 4.79902 9.33814C4.60921 9.33814 4.42051 9.2591 4.28564 9.10517L0.834277 5.15425C0.609928 4.89768 0.609928 4.51461 0.834277 4.25803L4.28561 0.307151C4.53333 0.024013 4.96341 -0.00505601 5.24678 0.24221Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.8398d9d82ca4abb5191ace0b69d61e6d.svg";
export { ForwardRef as ReactComponent };